<template>
  <div
    id="captcha-container"
    class="smart-captcha"
    :data-sitekey="apiToken"
    :ref="referenceName"
  ></div>
</template>

<script>
import { loadScript } from '@/common/helpers/loadSrcipt.js'

export default {
  name: 'YandexCaptcha',

  data: () => ({
    referenceName: 'captcha-container'
  }),

  props: {
    apiLink: {
      default: 'https://captcha-api.yandex.ru/captcha.js',
      type: String
    },
    apiToken: {
      required: true,
      type: String
    }
  },

  mounted() {
    loadScript(this.apiLink)
    const captchaContainer = this.$refs[this.referenceName]
    const captchaContainerObserver = new MutationObserver(() => {
      const input = captchaContainer.querySelectorAll('input[type="hidden"][name="smart-token"]')?.[0]
      if (input) {
        captchaContainerObserver.disconnect()
        new MutationObserver(() => {
          if (input.value) {
            this.$emit('captcha-solved', input.value)
          }
        }).observe(input, { attributes: true })
      }
    })
    captchaContainerObserver.observe(captchaContainer, { childList: true })
  }
}
</script>
